import type { ReactElement } from 'react';
import { Popover as AriaPopover, type PopoverProps } from 'react-aria-components';

/** Overlay surface. Renders into the UiProvider portal container (.tf-root). */
export function Popover(props: Omit<PopoverProps, 'className'>): ReactElement {
  return (
    <AriaPopover
      offset={4}
      {...props}
      className="m-0 p-0 border border-solid border-line rounded-panel bg-panel text-ink font-ui text-md shadow-popover z-popover"
    />
  );
}
